angular.module('aprima-core-ui').directive('apPharmacyAddress',
    ['DeviceSettings','$window',
        function (DeviceSettings, $window) {
            'use strict';

            return {
                restrict: 'E',                
                scope: {
                    address: '='
                },
                templateUrl: '/core-ui/views/directives/apPharmacyAddress.html',
                link: function($scope) {

                    $scope.openGMap = function () {
                        if(DeviceSettings.isPrm)
                        {                          
                            $window.open('https://maps.google.com/maps?q='+$scope.address.Address1+'  '+$scope.address.City+', '+$scope.address.State+' '+$scope.address.Zip, '_blank');                                             
                        }                                                
                    };                    
                                    
                },
                
            };
        }]);